import React from 'react'
import SALink from 'components/SALink'
import AppConnector, { ConnectorProps as AppProps } from '../connectors/App'
import { displayEllipticalString } from '../helpers'

const Component = ({
  collections,
  collectionsTotal,
  pageParamUserID,
}: AppProps): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-section='collection-section'>
      <h4 className='defaultTypographyH4' data-type='main-title'>
        Collections
      </h4>
      {collections.length ? (
        <>
          <div data-type='collection-tiles'>
            {collections.map((collection, index) => {
              const { title, artworksCount, artworkImage, collectionUrl } = collection
              return (
                <SALink data-type='tile' title='view collection' href={collectionUrl}>
                  <img src={artworkImage} data-type='image' alt={title} />
                  <div data-type='overlay'>
                    <span data-type='title'>
                      {title.length > 25 ? displayEllipticalString(title, 25) : title}{' '}
                    </span>
                    <span data-type='artwork-count'>({artworksCount}) </span>
                  </div>
                </SALink>
              )
            })}
          </div>
          <SALink href={`/account/collection/${pageParamUserID}`} data-type='view-all'>
            View All Collections
          </SALink>
        </>
      ) : (
        ''
      )}
    </div>
  )
}

export default AppConnector(Component)
